import { Spinner } from "@instacover/ui"

import { BaseLayout } from "./BaseLayout"

type Props = {
  hideLogo?: boolean
}

export function SpinnerLayout({ hideLogo }: Props) {
  return (
    <BaseLayout hideLogo={hideLogo} hideCounter hideLocales>
      <div className="h-vh-header flex flex-col items-center justify-center">
        <Spinner color="primary" size="2xl" />
      </div>
    </BaseLayout>
  )
}
